import { cmd } from './cmd/cmd.js';
import dotenv from 'dotenv';

dotenv.config();
cmd();
